import BaseService from './Base';

class DynamicFormService extends BaseService {
  static endpoint = 'api/2.0/dynamic-forms/';
}

export default DynamicFormService;